import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CaseDescriptor } from './model/case';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class CaseService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'CaseManagement',
      authService,
      config.CAMSConfig
    );

  }

  public create(caseEntity: CaseDescriptor): Promise<CaseDescriptor> {
    return super.post<CaseDescriptor>(
      new CaseDescriptor({
        id: undefined,
        href: undefined,
        identifier: caseEntity.identifier,
        categoryId: caseEntity.categoryId,
        organizationId: caseEntity.organizationId,
        formId: caseEntity.formId,
        periodStart: caseEntity.periodStart,
        subject: caseEntity.subject,
        anonymousCreatorEmailAddress: caseEntity.anonymousCreatorEmailAddress,
        caseState: caseEntity.caseState,
        createdBy: caseEntity.createdBy,
        createdOn: caseEntity.createdOn,
        assignedTo: caseEntity.assignedTo,
        responsible: caseEntity.responsible,
        modified: caseEntity.modified,
        deleted: caseEntity.deleted
      }));
  }

  public getCases(view?: View): Promise<List<CaseDescriptor>> {
    return super.get<List<CaseDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, role: CaseDescriptor): Promise<CaseDescriptor> {
    return super.put<CaseDescriptor>(id, role);
  }

  public getById(id: string): Promise<CaseDescriptor> {
    return super.get<CaseDescriptor>(id);
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/case/case.service.ts